import { EditProjectContextProps } from "../../EditProjectContext";
import { getSupplierTransitTime } from "./GetSupplierTransitTime";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";

export function setPropertyOnLtlPipeline(
  spdrOrPsrId: number,
  name: string,
  value: string | string[] | number | undefined,
  editProjectContext: EditProjectContextProps
) {
  const { project, setProject } = editProjectContext;

  function getTtAdjustment(ltlPipelineItem: LtlPipelineViewModel) {
    return name === "TTAdjustment"
      ? (value as number)
      : ltlPipelineItem.TTAdjustment;
  }

  const ltlPipelines = project?.ltlPipelines?.map((ltlPipelineItem) => {
    if (
      ltlPipelineItem.SpdrId !== spdrOrPsrId &&
      ltlPipelineItem.PdsrId !== spdrOrPsrId
    ) {
      return ltlPipelineItem;
    }
    return {
      ...ltlPipelineItem,
      [name as never]: value,
      SupplierTransitTime: getSupplierTransitTime(
        ltlPipelineItem.routing,
        getTtAdjustment(ltlPipelineItem)
      ).toString(),
    };
  });

  setProject({ ...project, ltlPipelines });
}
